module.exports = __webpack_public_path__ + "static/media/nccer.2722d2c5.svg";